/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitor
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.call(this);
};
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase,
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped"
                 );



/**
 * resizeToViewport
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 1) disable the scroll monitor, it messes us up for our sizing of the viewport
 *	 2) If we have focus and on iphone or ipad, we want to
 *		2a) scroll to the bottom, this requires us to:
 *			* change the clients body style to allow us to scroll down, we change the minHeight and minWidth
 *			* to set listener for scroll the scroll down.
 *			* At completion of scroll down, get viewport and restore body minHeight and minWidth
 *			* Reenable scroll monitor
 *	3) No focus,
 *		get viewport size
 *		reenable scroll monitor
 *
 * We will get the size of the keyboard and use it for later, we do NOT have to keep going to the bottom of the page to calculate the screen size
 * We will keep a keyboard height for portrait and for landscape modes.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function resizeToViewport():Void
 * @public
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped.prototype.resizeToViewport = function(from) {
    // If chat is minimized, I do not want to resize chat.
    if(this.bResizeToViewport
       || com.inq.flash.client.control.MinimizeManager.minimized)
        return;
	this.bResizeToViewport = true;
	/** @type {Window} */
	var clientWin = window.top;
	com.inq.flash.client.chatskins.ScrollMonitor.unbindAll();

    // if its a device with a virtual keyboard and we are responding to focus event ( on a text input ).. we are resizing to make room for keybd
	if(this.hasFocus &&(com.inq.utils.Capabilities.isPhone() || com.inq.utils.Capabilities.isIpad())) {
		// just in time event binding... to handle scroll of window when keyboard bumps it up
		/** @type {Function} */
		var scrollListener ;
		/** @type {number} */
		var keyboardHeight = this.getKeyboardHeight();
		if (keyboardHeight == null) {		/* If we have the keyboard height, then use it, otherwise calculate it and keep it */
			com.inq.utils.Capabilities.BindListener(clientWin,"scroll", scrollListener = function(event){
				/* We have scrolled down so we can now get the viewable area, and calculate the keyboard height */
				viewPort = com.inq.utils.Capabilities.getViewport();
				if (!com.inq.utils.Capabilities.isIphone()) {	/* If we are NOT an iPhone then do the rendering and sizing bellow */
					Application.SetArea(viewPort);
					Application.Resize();

					this.zoomViewport(clientWin);

					// Delay allows DOM to re-render before we try to scroll.
					// However, Android takes its sweet time about
					// re-rendering, and doesn't schedule things like iOS
					// does, so we have to add a longer delay.
					if (com.inq.utils.Capabilities.isAndroid()) {
						com.inq.utils.Capabilities.waitFor(com.inq.utils.Capabilities.viewportStopsMoving(800), 200, function() {
							com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
						});
					}
					else {
						com.inq.utils.Timer.delay(function() {
							com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
						}, 1);
					}
				}
				/* Restore Scroll Listeners */
				com.inq.utils.Capabilities.UnbindListener(clientWin,"scroll", scrollListener);

				/***** code to calculate the keyboard size for iPhones Only *****/
				if (com.inq.utils.Capabilities.isIphone()) {
					var scrollListenerToOrigin;
					com.inq.utils.Capabilities.BindListener(clientWin,"scroll", scrollListenerToOrigin = function(event){
						com.inq.utils.Capabilities.UnbindListener(clientWin,"scroll", scrollListenerToOrigin);

						keyboardHeight = clientWin.innerHeight - viewPort.h;

						if (keyboardHeight>0) {	/* Save the keyboard height and recalculate the viewport */
							this.setKeyboardHeight(keyboardHeight);
							this.resizeToViewportFocused();
						} else {
							keyboardHeight = null;
						}
					});
					clientWin.scrollTo(0,1);
				}

				/* Restore scroll position via timer delay */
				/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase} */
				var __this__ = this;
				com.inq.utils.Timer.delay(function() {
					__this__.FixIPhoneFocusScroll();
				},0);
				com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
				this.bResizeToViewport = false;
				return false;
			});

			clientWin.scrollTo(0, clientWin.document.documentElement.offsetHeight);		/* now scroll all the way down */
		} else {
			/* If we are here, then we know the keyboard height and we can calculate the viewport size */
			this.resizeToViewportFocused();
			this.bResizeToViewport = false;
		}
	} else {
		this.zoomViewport(clientWin);
		com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
		try {
			viewPort = com.inq.utils.Capabilities.getViewport();
			Application.SetArea(viewPort);
			Application.Resize();
			this.bResizeToViewport = false;
		} catch (err) {
			haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplBase.js", lineNumber : 111, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase", methodName : "resizeToViewport"});
			this.bResizeToViewport = false;
		}
	}
};

